import React, { useEffect, useState } from "react";
import { fetchUserById } from "../../../services/AgentServices";

function ManageProfile() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const user_id = sessionStorage.getItem("userId");
  const client_id = sessionStorage.getItem("clientId");

  useEffect(() => {
    if (!user_id || !client_id) {
      setError("User ID or Client ID is missing.");
      return;
    }

    setIsLoading(true);
    fetchUserById(user_id, client_id)
      .then((data) => {
        setUser(data);
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [user_id, client_id]);

  if (error) {
    return <div className="alert alert-danger mt-5 text-center">Error: {error}</div>;
  }
  if (isLoading) {
    return <div className="alert alert-info mt-5 text-center">Loading user…</div>;
  }
  if (!user) {
    return <div className="alert alert-warning mt-5 text-center">No user found for ID {user_id}</div>;
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-10 col-md-8 col-lg-6">
          <div className="card shadow border-0">
            <div className="card-header bg-primary text-white text-center">
              <h5 className="mb-0">My Profile</h5>
            </div>
            <div className="card-body text-center">
              <div className="mb-4">
                <i className="fas fa-user-circle fa-4x text-secondary"></i>
              </div>
              <ul className="list-group list-group-flush text-start">
                <li className="list-group-item">
                  <i className="fas fa-user me-2 text-primary"></i>
                  <strong>Name:</strong> {user.user_name}
                </li>
                <li className="list-group-item">
                  <i className="fas fa-envelope me-2 text-primary"></i>
                  <strong>Email:</strong> {user.email}
                </li>
                <li className="list-group-item">
                  <i className="fas fa-phone me-2 text-primary"></i>
                  <strong>Phone:</strong> {user.mobile}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageProfile;
